import isNumber from "lodash/isNumber";

import { useStateQuery } from "@/lib/useStateQuery";

export function useCommunityId() {
  const [communityId, setCommunityId, buildNewCommunityIdUrl] = useStateQuery<
    number | undefined
  >("communityId", {
    queryToValue: v => (v !== undefined && isNumber(+v) ? +v : undefined),
    valueToQuery: v => (isNumber(v) ? String(v) : undefined),
  });

  return { communityId, setCommunityId, buildNewCommunityIdUrl };
}
